import { createStore } from '@stencil/store';
import { ToastState } from 'types';

const { state, onChange, reset } = createStore<ToastState>({
  isOpen: false,
  type: 'info',
  loader: false,
  verticalPosition: 'bottom',
  horizontalPosition: 'center',
});

onChange('isOpen', newValue => {
  if (newValue) {
    setTimeout(() => {
      state.isOpen = false;
    }, 5000);
  } else {
    state.loader = false;
    state.type = 'info';
    state.verticalPosition = 'bottom';
    state.horizontalPosition = 'center';
    state.text = undefined;
    state.title = undefined;
  }
});

window.document.addEventListener('reset-chat-stores', () => {
  reset();
});

export default state;
